import React, {useState} from "react";
import styled from "styled-components";
import KR from "../../img/KR.png"
import EN from "../../img/English.png"
import CN from "../../img/中國語.png"
import JP from "../../img/日本語.png"
import FR from "../../img/Français.png"
import SP from "../../img/Español.png"
import GR from "../../img/Deutsch.png"
import RU from "../../img/Русский.png"
import { useCookies } from 'react-cookie';


const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        position:fixed;
        top:0px;
        background-color:#000000;
        opacity:50%;
        z-index:4;
    `,
    WrapBox:styled.div`
        width:100%;
        height:90%;
        background-color:#ffffff;
        position:fixed;
        top:15%;
        z-index:5;
        border-radius:20px 20px 0px 0px;
        display:flex;
        justify-content:space-between;
        align-items:center;
        flex-direction:column;
    `,
        Header:styled.div`
            width:100%;
            height:60px;
            display:flex;
            justify-content:center;
            align-items:center;
            flex-direction:column;
            margin-top:20px;
        `,
            HeaderText:styled.p`
                font-size:18px;
                font-weight:600;
                margin:0px;
                font-family:'PreFont';
            `,

        ConTentWrap:styled.div`
            width:90%;
            height:70%;
            display:flex;
            justify-content:space-around;
            align-items:center;
            flex-direction:row;
            flex-wrap:wrap;
        `,
            ContentBox:styled.div`
                width:48.43%;
                height:23%;
                border-radius:10px;
                background-color:#F2F2F7;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:column;
                background-color: ${({ isSelected }) => (isSelected ? "#2277F6" : "#F2F2F7")};
                &:hover{
                    background-color:#2277F6;
                    font-size:20px;
                    font-weight:600;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                }
            `,
                Content:styled.div`
                    width:50px;
                    height:60.3px;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    flex-direction:column;
                `,
                ContentImg:styled.img`
                    width:50px;
                    height:33.3px;
                `,
                ContentText:styled.p`
                    font-size:16px;
                    font-weight:600;
                    color: ${({ isSelected }) => (isSelected ? "#ffffff" : "#030303")};
                    margin:0px;
                    font-family:'PreFont';
                `,

        Footer:styled.div`
            width:100%;
            height:100px;
            display:flex;
            justify-content:center;
            align-items:flex-start;
            flex-direction:row;
            margin-bottom:10px;
            box-shadow: 0px 0px 20px #eeeeee;
        `,
            CallBtn:styled.div`
                width:90%;
                height:50px;
                border-radius:10px;
                background-color:#2277F6;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
                margin-top:10px;
            `,
                BtnText:styled.p`
                    font-size:16px;
                    font-weight:400;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                `,
}
const Lang=(props)=>{
    const {LangSetting, setLangSetting, NowLang, setNowLang} = props
    const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);
    const [ChoiceMenu, setChoiceMenu] = useState([
        {
            title:"한국어",
            languageImg:KR,
            language:"KR"
        }, 
        {
            title:"English",
            languageImg:EN,
            language:"EN"
        },
        {
            title:"中國語",
            languageImg:CN,
            language:"CN"
        },
        {
            title:"日本語",
            languageImg:JP,
            language:"JP"
        },
        {
            title:"Français",
            languageImg:FR,
            language:"FR"
        },
        {
            title:"Español",
            languageImg:SP,
            language:"SP"
        },
        {
            title:"Deutsch",
            languageImg:GR,
            language:"GR"
        },
        {
            title:"Русский",
            languageImg:RU,
            language:"RU"
        }])
        
    if(LangSetting === false){
        return(
            <></>
        )
    }else{
        return(
            <>
                <Styled.Wrap onClick={()=>{setLangSetting(false)}}/>
                <Styled.WrapBox>
                    <Styled.Header>
                        <Styled.HeaderText>언어를 선택해주세요</Styled.HeaderText>
                        <Styled.HeaderText>Choose Language</Styled.HeaderText>
                    </Styled.Header>
                    <Styled.ConTentWrap>
                        {ChoiceMenu.map((v) => {
                            const isSelected = v.language === NowLang;
                                return (
                                    <Styled.ContentBox
                                        key={v.language}
                                        isSelected={isSelected}
                                        onClick={() => {
                                            setNowLang(v.language);
                                            setLangCookie("PageLang", v.language, { path: "/", maxAge: 60 * 60 * 24 * 365 });
                                        }}
                                    >
                                        <Styled.Content>
                                            <Styled.ContentImg src={v.languageImg} />
                                            <Styled.ContentText
                                                isSelected={isSelected}
                                            >{v.title}</Styled.ContentText>
                                        </Styled.Content>
                                    </Styled.ContentBox>
                                );
                            })}

                    </Styled.ConTentWrap>
                    <Styled.Footer>
                        <Styled.CallBtn onClick={()=>{setLangSetting(false)}}>
                            <Styled.BtnText>언어선택</Styled.BtnText>
                        </Styled.CallBtn>
                    </Styled.Footer>
                </Styled.WrapBox>
            </>
        )
    }
}
export default Lang